import { BaseComponent } from '../core/BaseComponent';

export class FileUpload extends BaseComponent {
  private area: HTMLElement | null = null;
  private input: HTMLInputElement | null = null;
  private list: HTMLElement | null = null;

  protected init(): void {
    super.init();
    this.area = this.element.querySelector('.upload-area');
    this.input = this.element.querySelector('.upload-input');
    this.list = this.element.querySelector('.upload-list');
    
    if (this.input) {
      this.input.addEventListener('change', (e) => {
        const files = (e.target as HTMLInputElement).files;
        if (files) this.handleFiles(files);
      });
    }
    
    if (this.area) {
      ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(name => {
        this.area?.addEventListener(name, (e) => {
          e.preventDefault();
          e.stopPropagation();
        });
      });

      this.area.addEventListener('dragover', () => this.area?.classList.add('dragover'));
      this.area.addEventListener('dragleave', () => this.area?.classList.remove('dragover'));
      this.area.addEventListener('drop', (e) => {
        this.area?.classList.remove('dragover');
        const files = e.dataTransfer?.files;
        if (files) this.handleFiles(files);
      });
    }
  }

  public handleFiles(files: FileList): void {
    Array.from(files).forEach(file => this.addFile(file));
  }

  private addFile(file: File): void {
    const item = document.createElement('div');
    item.className = 'upload-item';
    item.innerHTML = `
      <div class="upload-item-name">${file.name}</div>
      <div class="upload-progress">
        <div class="upload-progress-bar" style="width: 0%"></div>
      </div>
    `;
    this.list?.appendChild(item);

    let progress = 0;
    const interval = setInterval(() => {
      progress += Math.random() * 30;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
        setTimeout(() => item.classList.add('completed'), 500);
      }
      const bar = item.querySelector('.upload-progress-bar') as HTMLElement;
      if (bar) bar.style.width = progress + '%';
    }, 300);
    
    this.emit('upload', { file });
  }
}
